import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

const StyledBaseCallToAction = styled('button', {
  shouldForwardProp,
})(
  css({
    alignItems: 'center',
    appearance: 'none',
    borderWidth: 0,
    outline: 0,
    cursor: 'pointer',
    display: 'flex',
    fontFamily: 'body',
    justifyContent: 'center',
    maxWidth: '100%',
    textDecoration: 'none',
    width: 'auto',
    flex: 'none',
    ':disabled': {
      cursor: 'not-allowed',
    },
  })
);

const BaseCallToAction = forwardRef<HTMLButtonElement>(
  ({ children, ...rest }, ref) => (
    <StyledBaseCallToAction ref={ref} {...rest}>
      {children}
    </StyledBaseCallToAction>
  )
);

export default BaseCallToAction;
